import {quesCatTypes} from '../../../reducers/settings/settingsTypes'
import {questionCategoryService} from '../../../service/settings/question/categoryServices'


export const quesCatActions = {
    getAllQuestionCategories,
    createCategory,
    updateCategory,
    deleteCategory
}

function getAllQuestionCategories(limit, offset, sort_column, sort_direction, search_term)  {
    return async dispatch => {
        try {
            dispatch(clearExisting());
            dispatch(request());

            let categories = await questionCategoryService.getAllQuestionCategories(limit, offset, sort_column, sort_direction, search_term) ;
            dispatch(success(categories.data))
        }catch (error) {
            dispatch(failure(error.toString()))
        }
    };
    function clearExisting() {
        return {type: quesCatTypes.GET_ALL_QUESTION_CATEGORIES}
    }

    function request() {
        return {type: quesCatTypes.GET_ALL_QUESTION_CATEGORIES_REQUEST}
    }

    function success(categories) {
        return {type: quesCatTypes.GET_ALL_QUESTION_CATEGORIES_SUCCESS, categories}
    }

    function failure(error) {
        return {type: quesCatTypes.GET_ALL_QUESTION_CATEGORIES_FAILURE, error}
    }
}


function createCategory(obj) {
    return async dispatch => {
        try {
            dispatch(request(obj));
            let res = await questionCategoryService.createCategory(obj);
            if (res.success) {
                dispatch(success(res.data));
            } else {
                dispatch(failure(res.message));  
            }
        } catch (error) {
            dispatch(failure(error));
        }
    };

    function request(data) {
        return {type: quesCatTypes.CREATE_CATEGORY_REQUEST, data}
    }

    function success(types) {
        return {type: quesCatTypes.CREATE_CATEGORY_SUCCESS, types}
    }

    function failure(error) {
        return {type: quesCatTypes.CREATE_CATEGORY_FAILURE, error}
    }
}


function deleteCategory(obj) {

    return async dispatch => {
        dispatch(request(obj));
        try {
            let res = await questionCategoryService.deleteCategory(obj);
            if (res.success) {
                dispatch(success(res.data));
            } else {
                dispatch(failure(res.message));  
            }
        } catch (error) {
            dispatch(failure(error.toString()));
        }
    };

    function request(category) {
        return {type: quesCatTypes.DELETE_CATEGORY_REQUEST, category}
    }

    function success(success) {
        return {type: quesCatTypes.DELETE_CATEGORY_SUCCESS, success}
    }

    function failure(error) {
        return {type: quesCatTypes.DELETE_CATEGORY_FAILURE, error}
    }
}

function updateCategory(obj) {
    return async dispatch => {

        dispatch(request());

        try {
            let res = await questionCategoryService.updateCategory(obj);
            if (res.success) {
                dispatch(success(res.data));
            } else {
                dispatch(failure(res.message));  
            }
        } catch (error) {
            dispatch(failure(error.toString()));
        }
    };

    function request() {
        return {type: quesCatTypes.UPDATE_CATEGORY_REQUEST}
    }

    function success(category) {
        return {type: quesCatTypes.UPDATE_CATEGORY_SUCCESS, category}
    }

    function failure(error) {
        return {type: quesCatTypes.UPDATE_CATEGORY_FAILURE, error}
    }
}
